export default __webpack_public_path__ + "static/media/shopping-bag-2.84581004.svg";